import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import beforeIntervention from "./components/before-intervention";
import afterIntervention from "./components/after-intervention";

const principle: Slide = {
  description:
    "See the difference in sound reduction properties of a horizontal party element ending at a curtain wall, before and after an acoustic intervention. The state of construction before the intervention and the corresponding sound reduction index are shown in the images. Listen to the sound samples to perceive this difference. Use headphones and adjust the listening level so that male voice in the source room sounds realistically loud.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Before intervention" }, { name: "After intervention" }],
        },
      ],
      extraContent: [[], []],
      components: [beforeIntervention, afterIntervention],
    },
  },
};

export default principle;
